import { useLocation } from 'react-router-dom'

const useSignTableParams = () => {
  const { search } = useLocation()

  const query = new URLSearchParams(search)

  const nameParam = query.get('name')

  const userParam = query.get('user')

  const fromParam = query.get('date[from]')

  const toParam = query.get('date[to]')
  return {
    nameParam,
    userParam,
    fromParam,
    toParam,
  }
}

export default useSignTableParams
